import { useContext } from 'react';
import AlertContext from './PopUpAlertContext';

const useAlert = () => useContext(AlertContext);

export default useAlert;